package com.essntl.uikit.components.dropdown

import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.DpOffset
import androidx.compose.ui.unit.dp
import com.essntl.uikit.components.button.flat.EsSmallFlatButton
import com.essntl.uikit.components.spinner.EsSpinner
import com.essntl.uikit.components.spinner.EsSpinnerSize
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun <T> EsFilterDropDownMenu(
    expanded: Boolean,
    onDismissRequest: () -> Unit,
    list: List<T>,
    selectedItemIds: Set<T>,
    onClearAll: () -> Unit = {},
    clearing: Boolean = true,
    loading: Boolean = false,
    content: @Composable ColumnScope.() -> Unit,
    modifier: Modifier = Modifier,
) {
    EsDropDownMenu(
        expanded = expanded,
        onDismissRequest = onDismissRequest,
        modifier = modifier,
        paddingValues = PaddingValues(
            vertical = 1.5f.spacing,
        ),
        offset = DpOffset(
            x = 0.dp,
            y = 4.dp,
        ),
    ) {
        if (loading) {
            EsSpinner(
                color = MaterialTheme.esColorScheme.iconPrimary,
                size = EsSpinnerSize.Large,
                modifier = Modifier
                    .align(Alignment.CenterHorizontally)
                    .padding(all = 1.5f.spacing),
            )
        } else if (list.isEmpty()) {
            Text(
                text = "Nothing was found",
                color = MaterialTheme.esColorScheme.textTertiary,
                style = MaterialTheme.esTypography.p1Regular16,
                modifier = Modifier
                    .align(Alignment.Start)
                    .padding(all = 1.5f.spacing),
            )
        }

        if (clearing)
            EsSmallFlatButton(
                onClick = onClearAll,
                text = "Clear all",
                enabled = selectedItemIds.isNotEmpty() && !loading,
                modifier = Modifier
                    .align(Alignment.End),
            )

        content()
    }
}